export const GOOGLE_MAP_KEY =
  process.env.GATSBY_GOOGLE_MAP_KEY || 'AIzaSyDjWP1ADMYW7bNE1ifZpwdLIZrkohcbe0Q'

export const JWT_KEY = process.env.REACT_APP_JWT_KEY || 'kXbUecFnekZYZ9q7NxsQp5hCldz9DDdk'
